
import React from 'react';

interface GlowCardProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  id?: string;
}

const GlowCard: React.FC<GlowCardProps> = ({ children, className = '', delay = 0, id }) => {
  return (
    <div
      id={id}
      className={`group relative p-8 bg-surface border border-white/5 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-accent/40 ${className}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-accent/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
      <div className="absolute -inset-px bg-gradient-to-br from-accent/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity blur-xl -z-10"></div>
      {children}
    </div>
  );
};

export default GlowCard;
